<template>
  <b-form-group
    label="5. Gedung Dan Bangunan Di Atas Tanah Milik"
    label-for="gedungBangunanTanahMilik"
  >
    <b-form-select
      v-model="gedungBangunanTanahMilik"
      :options="dataGedungBangunanTanahMilik"
      disabled
    />
    <b-col
      v-if="gedungBangunanTanahMilik === '1'"
      cols="11"
      offset-md="1"
      class="mt-1 pr-0"
    >
      <b-form-radio
        v-model="isGedungBangunanTanahMilikTercatat"
        value="1"
        disabled
      >
        Sudah Tercatat
      </b-form-radio>

      <b-form-radio
        v-model="isGedungBangunanTanahMilikTercatat"
        value="0"
        disabled
      >
        Belum Tercatat
      </b-form-radio>

      <b-col
        v-if="isGedungBangunanTanahMilikTercatat == '0'"
        cols="11"
        offset-md="1"
        class="mt-1 pr-0"
      >
        <b-form-group
          label="Keterangan"
          label-for="gedungBangunanTanahMilikKeterangan"
          label-size="lg"
          label-class="pb-0 pt-0"
        >
          <slot name="gedungBangunanTanahMilikKeterangan" />
        </b-form-group>
      </b-col>
    </b-col>
    <b-col
      v-if="
        gedungBangunanTanahMilik === '2' ||
          gedungBangunanTanahMilik === '3' ||
          gedungBangunanTanahMilik === '4'
      "
      cols="11"
      offset-md="1"
      class="mt-1 pr-0"
    >
      <b-form-group
        label="Sebutkan"
        label-for="gedungBangunanTanahMilikSebutkan"
      >
        <slot name="gedungBangunanTanahMilikSebutkan" />
      </b-form-group>
    </b-col>
  </b-form-group>
</template>
<script>
export default {
  props: {
    gedungBangunanTanahMilik: { type: String, default: null },
    isGedungBangunanTanahMilikTercatat: { type: String, default: null },
  },
  data() {
    return {
      dataGedungBangunanTanahMilik: [
        { value: null, text: '-- Pilih Salah Satu --' },
        { value: '1', text: 'Pemerintah Daerah Provinsi DKI Jakarta' },
        { value: '2', text: 'Pemerintah Pusat' },
        { value: '3', text: 'Pemerintah Daerah Lain' },
        { value: '4', text: 'Pihak Lain' },
      ],
    }
  },
}
</script>
